import './App.css';

import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import Footer from './components/commons/Footer/FooterV2';
import CompWiki from './components/pages/Componentes/CompWiki';
import ListadoProcedimientos from './components/pages/listadoProcedimientos/ListadoProcedimientos';
import AltaUsuario from './components/pages/pageAltaUsuario/PageAltaUsuario';
import ListadoNoticias from './components/pages/listadoNoticias/ListadoNoticias';
import AndaluciaSegura from './components/pages/andaluciaSegura/AndaluciaSegura';
import seleccionConvocatoriaPerfil from './components/pages/seleccionConvocatoriaPerfil/SeleccionConvocatoriaPerfil';
import LoginAdministrador from './components/pages/loginAdministrador/LoginAdministrador';
import ListadoFormularios from './components/pages/listadoFormularios/ListadoFormularios';
import CreacionFormularios from './components/pages/creacionFormularios/CreacionFormularios';
import RespuestaClave from './components/pages/respuestaClave/RespuestaClave';
import Header from './components/commons/header/Header'
import ServiciosAtencionCiudadania from './components/pages/serviciosAtencionCiudadania/serviciosAtencionCiudadania';
import ScrollToTop from './components/commons/scrollToTop/scrollToTop';
import { properties } from './AppData'
import AppContext from 'AppContext';
import BandejaSolicitudes from './components/pages/bandejaSolicitudes/BandejaSolicitudes';
import NuevaSolicitud from 'components/pages/nuevaSolicitud/NuevaSolicitud';
import MenuNavegacion from 'components/pages/menuNavegacion/MenuNavegacion';
import ComponenteFormio from 'components/pages/componenteFormio/ComponenteFormio';
import AporteDocumentacion from 'components/pages/aporteDocumentacion/AporteDocumentacion';
import VisualizadorPdf from 'components/commons/visualizadorPdf/VisualizadorPdf';
import FirmaSolicitud from 'components/pages/firmaSolicitud/FirmaSolicitud';
import SolicitudPresentadaCorrectamente from 'components/pages/solicitudPresentadaCorrectamente/SolicitudPresentadaCorrectamente';
import HistoricoDocumentos from 'components/pages/historicoDocumentos/HistoricoDocumentos';
import AporteMejoraDocumentacion from 'components/pages/aporteMejoraDocumentacion/AporteMejoraDocumentacion';
import ReactGA from 'react-ga4';
import { googleAnalytics } from 'AppData';
import { localStorageName } from 'providers/localStorageData';
import MatrizCompatibilidad from 'components/pages/matrizCompatibilidad/MatrizCompatibilidad';
import Desistimiento from 'components/pages/desistimiento/Desistimiento';
import Accesibilidad from 'components/pages/accesibilidad/Accesibilidad';
import SelloElectronicoSistemasFirma from 'components/pages/selloElectronicoSistemaFirma/SelloElectronicoSistemasFirma';
import useProtectedRoutes from 'providers/useProtectedRoutes';
import PageNotFound from 'components/pages/pageNotFound/PageNotFound';
import AltaAnexo from 'components/pages/pageAltaAnexo/PageAltaAnexo';
import AltaEntidadColaboradora from 'components/pages/formAltaEntidadColaboradora/altaEntidadColaboradora';
import PageAccesoConContrasena from 'components/pages/pageAccesoConContrasena/PageAccesoConContrasena';
import AltaUsuarioConContrasena from 'components/pages/altaUsuarioConContrasena/altaUsuarioConContrasena';
import SolicitarContrasena from 'components/pages/solicitarContrasena/SolicitarContrasena';
import RestaurarContrasena from 'components/pages/restaurarContrasena/RestaurarContrasena';

function App() {

  const { ProtectedRoute } = useProtectedRoutes();

  const [title, setTitle] = useState();
  const [sesion, setSesion] = useState();

  const contextPack = {
    titlePage: title,
    updateTitlePage: (newTitle) => setTitle(newTitle),
    sesion: sesion,
    updateSesion: (estado) => setSesion(estado)
  };

  /***** Google Analytics *****/
  //Paso 1. Se obtiene la ruta actual de la página en la que nos encontramos
  let location = window.location.hash;
  //Paso 2. Se crea un efecto que se ejecutará cada vez que la variable location cambie
  useEffect(() => {
    //Paso 3. Se indica cual es nuestro ID de Seguimiento 
    ReactGA.initialize(googleAnalytics);
    //Paso 4. Se realiza un tratamiento de la cadena que contiene la ruta de la página actual
    location = location.substr(1, location.length);
    //Paso 5. Se inserta la página que se está visitando
    ReactGA.send({ hitType: 'pageview', page: location, title: contextPack.titlePage });
    //Paso 6. Se insertan eventos
    //Paso 6.1 Se inserta un evento en el que muestra que procedimiento se está visitando
    location === '/SeleccionConvocatoriaPerfil' &&
      ReactGA.event({
        category: 'Procedimientos', //Categoría del evento
        action: contextPack.titlePage //Acción del evento
      });
  }, [location]);

  window.addEventListener(properties.EVENT_UNLOAD, (() => {
    localStorage.removeItem(localStorageName.token);
  }));

 

  return (
    <AppContext.Provider value={contextPack}>
      <Helmet htmlAttributes={{ lang: 'es' }}>
        <title>{properties.TITULO_PAGINA + title}</title>
      </Helmet>
      <Router>
        <ScrollToTop />
        <Header />

        <Switch>
          <Route path={["/", "/retorno.do", "/cerrarSesion.do"]} exact component={ListadoProcedimientos} />
          <Route path='/seleccionConvocatoriaPerfil/:idProcedimiento' exact component={seleccionConvocatoriaPerfil} />
          <Route path='/AltaUsuario' exact component={AltaUsuario} />
          <Route path='/AndaluciaSegura/:idExpediente' exact component={AndaluciaSegura} />
          <Route path='/Noticias' exact component={ListadoNoticias} />
          <Route path='/RespuestaClave/:datosUsarioClave' exact component={RespuestaClave} />
          <Route path='/PantallaContacto' exact component={ServiciosAtencionCiudadania} />          
          <Route path='/CreacionFormularios/:formPath' exact component={CreacionFormularios} />          
          <Route path={'/ComponenteFormio'} exact component={ComponenteFormio} />
          <Route path={'/MatrizCompatibilidad'} exact component={MatrizCompatibilidad}/>          
          <Route path='/Accesibilidad' exact component={Accesibilidad}/>
          <Route path='/SelloElectronicoSistemasFirma' exact component={SelloElectronicoSistemasFirma}/>
          <Route path='/RestaurarContrasena' exact component={RestaurarContrasena}/>
          {/******/}
         {/*  <ProtectedRoute path= '/LoginAdministrador' component={LoginAdministrador} />
          <ProtectedRoute path= '/MenuNavegacion' component={MenuNavegacion}/>
          <ProtectedRoute path= '/ListadoFormularios' component={ListadoFormularios} />
          <ProtectedRoute path= '/CreacionFormularios' component={CreacionFormularios} /> */} {/* Comentado para evitar que se muestre el menú de navegación */}
          <ProtectedRoute path= '/BandejaSolicitudes' component={BandejaSolicitudes} />
          <ProtectedRoute path= '/NuevaSolicitud' component={NuevaSolicitud} />
          <ProtectedRoute path= '/AporteDocumentacion' component={AporteDocumentacion} />
          <ProtectedRoute path= '/AporteMejoraDocumentacion' component={AporteMejoraDocumentacion} />
          <ProtectedRoute path= '/FirmaSolicitud' component={FirmaSolicitud} />
          <ProtectedRoute path= '/SolicitudPresentadaCorrectamente' component={SolicitudPresentadaCorrectamente} />
          <ProtectedRoute path= '/HistoricoDocumentos' component={HistoricoDocumentos} />
          <ProtectedRoute path= '/Desistimiento' component={Desistimiento}/>
          <ProtectedRoute path= '/AltaAnexo' component={AltaAnexo}/>
          <ProtectedRoute path= '/AltaEntidadColaboradora' component={AltaEntidadColaboradora}/>
          <ProtectedRoute path= '/AccesoConContrasena' component={PageAccesoConContrasena}/>
          <ProtectedRoute path= '/AltaUsuarioConContrasena' component={AltaUsuarioConContrasena}/>
          <ProtectedRoute path= '/SolicitarContrasena' component={SolicitarContrasena}/>
          <Route path="*" component={PageNotFound}/>
        </Switch>
        <Footer/>
      </Router>      
    </AppContext.Provider>
  );
}

export default App;
